module.exports = __webpack_public_path__ + "img/hotel-convento-salvador.9a67efb3.jpg";